var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateMealActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95432 8.95431 0 20 0H60C71.0457 0 80 8.95431 80 20V57.5757C80 68.6214 71.0457 77.5758 60 77.5758H20C8.95431 77.5758 0 68.6215 0 57.5758V20ZM37 22.5C37 20.567 38.567 19 40.5 19C42.433 19 44 20.567 44 22.5V35H56.5C58.433 35 60 36.567 60 38.5C60 40.433 58.433 42 56.5 42H44V54.5C44 56.433 42.433 58 40.5 58C38.567 58 37 56.433 37 54.5V42H24.5C22.567 42 21 40.433 21 38.5C21 36.567 22.567 35 24.5 35H37V22.5Z",
    fill: "#3B82F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38.5H57",
    stroke: "#1E293B",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 55V22",
    stroke: "#1E293B",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMealActive);
export default __webpack_public_path__ + "static/media/create-meal-active.5daeb5aa7200444bc5bcb5ec195584ae.svg";
export { ForwardRef as ReactComponent };